import { EntityRepository, Repository } from "typeorm";
import { AssetsClassification } from "../assets-classification-entity";



@EntityRepository(AssetsClassification)
export class AssetsClassificationRepository extends Repository<AssetsClassification>{

}
